import { render, staticRenderFns } from "./round-auto.vue?vue&type=template&id=0e0c9c32&scoped=true&"
import script from "./round-auto.vue?vue&type=script&lang=js&"
export * from "./round-auto.vue?vue&type=script&lang=js&"
import style0 from "./round-auto.vue?vue&type=style&index=0&id=0e0c9c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c9c32",
  null
  
)

export default component.exports